import {
  createContext,
  PropsWithChildren,
  ReactNode,
  useMemo,
  useState,
} from 'react';
import { Toast, ToastType } from '../Toast/Toast';

export const ToastContext = createContext<{
  displayToaster: (message: ReactNode, type: ToastType) => void;
}>({
  displayToaster: () => null,
});

export function ToastProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState<ReactNode>('');
  const [type, setType] = useState<ToastType>('info');

  const displayToaster = (newMessage: ReactNode, newType: ToastType) => {
    setIsOpen(true);
    setMessage(newMessage);
    setType(newType);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const value = useMemo(() => ({ displayToaster }), []);

  return (
    <ToastContext.Provider value={value}>
      <Toast
        message={message}
        onClose={handleClose}
        open={isOpen}
        type={type}
      />
      {children}
    </ToastContext.Provider>
  );
}
